import * as React from "react";
import { useTranslate } from "../helpers";
import {
  TealiumEventProps,
  sendTealiumEvent,
} from "../helpers/objectUtilities";

interface PrintButtonProps {
  tealiumProps?: TealiumEventProps;
  onClick?: () => void;
}

export const printPage = (): void => {
  // For some reason, window.print is not working in Safari even though it's a supported function
  if (!document.execCommand("print", false, undefined)) {
    window.print();
  }
};

const PrintButton: React.FunctionComponent<PrintButtonProps> = ({
  children,
  tealiumProps,
  onClick,
}) => {
  const t = useTranslate();

  return (
    <button
      onClick={
        onClick ||
        ((): void => {
          if (tealiumProps)
            // istanbul ignore next: tested elsewhere
            sendTealiumEvent(
              tealiumProps.event_action,
              tealiumProps.event_label
            );

          printPage();
        })
      }
      className="PrintButton mct-hide-print"
    >
      <span className="fa fa-print fa-lg" />
      <div>{children ? children : t("print")}</div>
    </button>
  );
};

export default PrintButton;
